module.exports = __webpack_public_path__ + "static/img/cell3.8be043e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cell3.png
// module id = U8h8
// module chunks = 0